import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { UpdateStandingsConfigurationModel } from "~pages/StandingsConfigurations/types/updateStandingsConfigurationModel.ts";
import type { StandingConfigurationResponse } from "~types/standingConfiguration.ts";

export const useUpdateStandingsConfiguration = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<StandingConfigurationResponse, Error, UpdateStandingsConfigurationModel>({
    mutationFn: async ({ standingConfigurationId, ...updateData }) =>
      await request<StandingConfigurationResponse>(`${sport}/o/${organizationId}/standings/configurations/${standingConfigurationId}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "standings.configuration.update.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["standingsConfigurations", sport, organizationId] });
    },
  });
};
